import React from "react";
import AllLaunches from "./container/board";
import CreateEthPump from "./container/create.tsx";
import NotFound from "./container/NotFound";
import BuyPage from "./container/BuyPage";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params';
import { WagmiProvider } from 'wagmi'
import Profile from "./container/Profile.tsx";
import ReferralPage from './container/Referral.tsx';
import toast, { ToastBar, Toaster } from "react-hot-toast";
import './index.css';
import Faq from "./container/Faq";
import About from "./container/About";
import Presale from "./container/Presale";
import Whitepaper from "./container/Whitepaper.jsx";
import { createWeb3Modal } from '@web3modal/wagmi/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { config } from './config.jsx'
import { ThemeProvider } from './context/ThemeContext';
import Blog from "./container/Blog.jsx";
import BlogLeft from "./container/Blog1.js";
import Blog1 from "./container/Blog1.js";

const projectId = '0471566f19c8ba8ee6264da2774e823d'

const queryClient = new QueryClient()
const currentUrl = window.location.origin;

const metadata = {
  name: 'FlazePad',
  description: 'FlazePad - Token Launchpad',
  url: currentUrl,
  icons: ['https://flazepad.xyz/img/logo-dark.png']
}

// Use the same config for both WagmiProvider and Web3Modal
// Initialize Web3Modal - ensure it's done before React renders
if (typeof window !== 'undefined' && !window.walletConnectInitialized) {
  try {
  createWeb3Modal({
    themeVariables: {
        '--w3m-accent': '#000000',
        '--w3m-border-radius-master': '1px',
        '--w3m-color-fg-1': '#ffffff',
        '--w3m-color-fg-2': '#ffffff',
        '--w3m-color-fg-3': '#ffffff',
        '--wui-color-accent-100': '#000000',
        '--wui-color-bg-100': '#000000',
        '--wui-color-bg-125': '#000000',
        '--wui-color-fg-1': '#ffffff',
        '--wui-color-fg-2': '#ffffff',
        '--wui-color-fg-3': '#ffffff'
    },
    projectId,
    metadata,
      wagmiConfig: config,
      enableNetworkView: true,
      enableAccountView: true
  });
  window.walletConnectInitialized = true;
    console.log('Web3Modal initialized successfully');
  } catch (error) {
    console.error('Error initializing Web3Modal:', error);
  }
}


const App = () => {
  return (
    <WagmiProvider reconnectOnMount config={config}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Router>
            <QueryParamProvider>
              <div className="mt-4">
                <Toaster
                  position="top-right"
                  reverseOrder={true}
                  toastOptions={{ duration: 5000 }}
                >
                  {t => (
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => toast.dismiss(t.id)}
                    >
                      <ToastBar onClick={() => alert(1)} toast={t} />
                    </div>
                  )}
                </Toaster>
                <Switch>
                  <Route exact path="/">
                    <AllLaunches />
                  </Route>
                  <Route exact path="/dashboard">
                    <AllLaunches />
                  </Route>
                  <Route exact path="/create">
                    <CreateEthPump />
                  </Route>
                  <Route exact path="/Buy">
                    <BuyPage />
                  </Route>
                  <Route exact path="/profile">
                    <Profile />
                  </Route>
                  <Route exact path="/whitepaper">
                    <Whitepaper />
                  </Route>
                  {/* <Route exact path="/faq">
                    <Faq />
                  </Route>
                  <Route exact path="/about">
                    <About />
                  </Route>
                  <Route exact path="/presale">
                    <Presale />
                  </Route>
                  <Route exact path="/blog">
                    <Blog />
                  </Route>
                  <Route exact path="/blog1">
                    <Blog1 />
                  </Route>
                  <Route exact path="/referral">
                    <ReferralPage />
                  </Route>
                  <Route exact path="/NotFound">
                    <NotFound />
                  </Route> */}
                </Switch>
              </div>
            </QueryParamProvider>
          </Router>
        </ThemeProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default App;
